import { matchPath } from 'react-router-dom';

import { NAV_REGISTRY } from 'src/config/navigation.registry';
import { bookList } from 'src/constants/bookList';
import { toReactRouterPath } from 'src/routing/pathUtils';

/**
 * True when the pathname matches a registered app route in NAV_REGISTRY.
 * Used to distinguish real app URLs (login required when signed out) from
 * dead bookmarks that should render the not-found page and must not become
 * post-auth redirect targets.
 *
 * @param {string} pathname
 * @returns {boolean}
 */
export const isRegisteredAppPath = (pathname) => {
    if (!pathname || pathname === bookList.notFound) {
        return false;
    }

    return NAV_REGISTRY.some((entry) => {
        const matchesRoutePath = entry.routePath
            && matchPath({
                path: toReactRouterPath(entry.routePath),
                end: false,
            }, pathname);

        const matchesNavPath = entry.navPath
            && matchPath({
                path: entry.navPath,
                end: false,
            }, pathname);

        return Boolean(matchesRoutePath || matchesNavPath);
    });
};
